<template>
    <product-card-layout-mobile
        :product-link="productLink"
        :name="product.name"
        :thumb="product.mainImage"
        :offers-count="product.offers && product.offers.length"
        :is-recommended="product.recommended"
        :is-package="isPackage"
        :_expanded-count="expanded"
        :_expanded-limit="expandedLimit"
        @change-expanded-count="expanded = $event"
        @change-expanded-limit="expandedLimit = $event"
    >
        <template v-slot>
            <div
                v-if="product.shortDescription"
                class="short-description mt-3"
                v-html="$filters.stripHtml(product.shortDescription)"
            />
            <v-row v-if="expanded">
                <v-col cols="12" class="my-3">
                    <div>
                        <date-filter-search v-model="dateFilter" outlined :dates-for-filter="datesForFilter" />
                    </div>
                </v-col>
            </v-row>
        </template>
        <template v-slot:price>
            <slot name="price" :offer="minPriceOffer">
                <template v-if="!minPriceOffer.soldOut">
                    <div class="font-weight-medium text-h6">
                        <span>{{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}</span>
                    </div>
                    <discount-label :price="minPriceOffer.price" />
                    <commission-amount :commission="minPriceOffer.price.commission" />
                </template>
            </slot>
        </template>
        <template v-slot:offers>
            <template v-if="groupOffersBy !== 'none'">
                <simple-tour-grouped-offers :date-filter="dateFilter" :sorted-filtered-offers="sortedFilteredOffers">
                    <template v-slot:price="{offer, offerKey}">
                        <slot name="price" :offer="offer" :offer-key="offerKey" />
                    </template>
                </simple-tour-grouped-offers>
            </template>
            <template v-else>
                <simple-tour-offer-card
                    v-for="(offer, offerIndex) in sortedFilteredOffers"
                    :key="offerIndex"
                    :offer="offer"
                    :full-card="false"
                >
                    <template v-slot:price="{offer}">
                        <slot name="price" :offer="offer" />
                    </template>
                </simple-tour-offer-card>
                <v-list-item
                    v-if="expanded === expandedLimit && product.offers.length > expandedLimit"
                    density="compact"
                    class="d-flex justify-center"
                    @click.stop="expand"
                >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-list-item>
            </template>
        </template>
    </product-card-layout-mobile>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import ProductCardLayoutMobile from '~/components/search/ProductCardLayoutMobile.vue'
    import SimpleTourOfferCard from '~/components/simpleTours/info/SimpleTourOfferCard.vue'
    import {SimpleTourCard} from '~src/components/simpleTours/search/offers/SimpleTourCard.vue'
    import SimpleTourGroupedOffers from '~/components/simpleTours/search/offers/SimpleTourGroupedOffers.vue'

    @Component({
        components: {
            DiscountLabel,
            CommissionAmount,
            ProductCardLayoutMobile,
            SimpleTourOfferCard,
            SimpleTourGroupedOffers,
        },
    })
    export class SimpleTourCardMobile extends SimpleTourCard {}

    export default SimpleTourCardMobile
</script>
